// AUTH-GOOGLE-01-B: build the exact arguments for supabase.auth.signInWithOAuth so every
// "Continue with Google" click requests Google's account chooser (prompt=select_account).
// Pure/testable. redirectTo remains the current dynamic origin + validated relative path; no
// provider/scope/callback change. `prompt=select_account` shows the chooser without signing the
// browser out of Google globally and without forcing a password each time.
export function buildGoogleOAuthArgs(origin, redirectTo) {
  return {
    provider: "google",
    options: {
      redirectTo: origin + redirectTo,
      queryParams: { prompt: "select_account" },
    },
  };
}
